import { render, staticRenderFns } from "./BookingProcess.vue?vue&type=template&id=b4ae4e88&scoped=true"
import script from "./BookingProcess.vue?vue&type=script&lang=js"
export * from "./BookingProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ae4e88",
  null
  
)

export default component.exports